export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtTexty';
export const NAME = 'Texty';
